define('views/home/notification',[
	'backbone',
	'views/_base/baseview',
	'text!views/home/notification.html',
], function (Backbone, BaseView, Template) {
	'use strict';

	return BaseView.extend({
		tagName: 'div',
		isRender: true,
		needsAuth: false,
		template: _.template(Template),
		events: {
			'click #pf-modal-close-btn': 'closeMODAL',
		},
		initialize: function (options) {
			var options = options || {};

			this.elementName = options.elementName;

			BaseView.prototype.initialize(this);
		},

		render: function () {
			var that = this;

			this.$el.html(this.template());

			return this;
		},

		closeMODAL: function () {
			// reset slider as manipulated in home.js showSunsettingModal f(x)
			$('#shop-home-preview-container').css('overflow-x', 'visible');
			$('#pf-modal-modern').fadeOut(function () {
				$('#pf-modal-modern').remove();
			});
		},

		close: function () {},
	});
});

